document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-header-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  const header = document.querySelector('[data-site-header]');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('is-solid', window.scrollY > 60);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      const selectedCharm = form.querySelector('input[name="charm_variant_id"]:checked');
      if (!selectedCharm) return;
      event.preventDefault();
      const selectedVariant = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
      const submit = form.querySelector('button[type="submit"]');
      if (!selectedVariant || !submit) return;
      submit.disabled = true;
      submit.textContent = 'Adding to bag…';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [
            { id: Number(selectedVariant.value), quantity: 1 },
            { id: Number(selectedCharm.value), quantity: 1, properties: { 'Paired with': document.querySelector('.product-title')?.textContent?.trim() || 'Nails By Her set' } }
          ] })
        });
        if (!response.ok) throw new Error('Cart add failed');
        window.location.href = '/cart';
      } catch (error) {
        submit.disabled = false;
        submit.textContent = 'Try again';
      }
    });
  });

  const finder = document.querySelector('[data-nbh-finder]');
  if (finder) {
    const copy = finder.querySelector('[data-finder-copy]');
    const link = finder.querySelector('[data-finder-link]');
    const choices = {
      fit: { copy: 'Start with the Size Guide to measure each nail at its widest point and find a considered fit before your first set.', label: 'Open the Size Guide', href: '/pages/size-guide' },
      apply: { copy: 'A calm application routine helps your set feel intentional. Follow the step-by-step guide before your first wear.', label: 'Read the application guide', href: '/pages/press-on-nail-application' },
      shop: { copy: 'Explore individual sets when you want a one-time edit, or compare monthly tiers when you want a recurring ritual.', label: 'Shop individual sets', href: '/collections/all' }
    };
    finder.querySelectorAll('[data-finder-choice]').forEach((button) => {
      button.addEventListener('click', () => {
        const choice = choices[button.dataset.finderChoice];
        if (!choice || !copy || !link) return;
        finder.querySelectorAll('[data-finder-choice]').forEach((item) => item.classList.remove('is-selected'));
        button.classList.add('is-selected');
        copy.textContent = choice.copy;
        link.textContent = choice.label;
        link.href = choice.href;
      });
    });
  }
});
